export const FEATURE_FLAGS = {
    IS_FOOTER_ENABLED: false,
    IS_FOOTER_AUTH_ENABLED: false,
    IS_NOTIFICATION_LIST_ENABLED: false,
    IS_DISPLAY_NAME_ENABLED: false,
    IS_PROFILE_SETTINGS_ENABLED: false,
    IS_GOOGLE_AUTH_ENBLAED: false,
};